

























































































































































































































































































































































































import { Component, Vue, Watch } from 'vue-property-decorator'
import Button from '@/app/ui/components/Button/index.vue'
import TextInput from '@/app/ui/components/TextInput/index.vue'
import DropdownCheckbox from '@/app/ui/components/DropdownCheckbox/index.vue'
import DataTable from '@/app/ui/components/DataTable/index.vue'
import PaginationNav from '@/app/ui/components/PaginationNav/index.vue'
import LoadingOverlay from '@/app/ui/components/LoadingOverlay/index.vue'
import TrashIcon from '@/app/ui/assets/trash_icon_alt.vue'
import EditIcon from '@/app/ui/assets/edit_icon.vue'
import ModalDelete from '../components/MarketplaceModal/ModalDelete.vue'
import ModalSuccess from '../components/MarketplaceModal/ModalSuccess.vue'
import controller from '@/app/ui/controllers/WhiteSellerController'
import WhiteSellerController from '@/app/ui/controllers/WhiteSellerController'
import { WhiteSeller, WhiteSellerPickupPoint } from '@/domain/entities/WhiteSeller'
import { Utils } from '@/app/infrastructures/misc'
import { Location } from 'vue-router'
import EyeIcon from '@/app/ui/assets/eye.vue'
import EyeDisabledIcon from '@/app/ui/assets/eye_disabled.vue'
import ChevronDownIcon from '@/app/ui/assets/chevron_down.vue'
import Badge from '@/app/ui/components/Badge/index.vue'
import PickupController from '@/app/ui/controllers/PickupController'

interface Params {
  page: number
  limit: number
  query: string
  status?: string
  sellerRole?: string
}

@Component({
  components: {
    Button,
    TextInput,
    DropdownCheckbox,
    DataTable,
    PaginationNav,
    LoadingOverlay,
    TrashIcon,
    EditIcon,
    ModalDelete,
    ModalSuccess,
    EyeIcon,
    EyeDisabledIcon,
    ChevronDownIcon,
    Badge,
  },
})
class ManageWhitelist extends Vue {
  controller = controller
  deleteModal = {
    show: false,
    ids: 0,
  }
  successDeleteModal = false
  isPopoverOpen = false

  // Address popup state
  activeAddressSellerId: number | null = null
  isLoadingAddressPopup = false
  addressPopupError = false
  addressPopupList: WhiteSellerPickupPoint[] = []
  addressPopupStyle: Record<string, string> = {}

  statusOptions = [
    { label: 'Aktif', value: 'ACTIVE' },
    { label: 'Tidak Aktif', value: 'INACTIVE' },
  ]

  sellerRoleOptions = [
    { label: 'Tokopedia', value: 'TOKOPEDIA' },
    { label: 'Bukalapak', value: 'BUKALAPAK' },
    { label: 'Aggregator', value: 'CLIENT' },
    { label: 'Corporate', value: 'COMPANY' },
    { label: 'Merchant', value: 'MERCHANT' },
  ]

  appliedStatus: string[] = []
  appliedRole: string[] = []

  draftStatus: string[] = []
  draftRole: string[] = []

  parameters = {
    page: 1,
    limit: 50,
    query: '',
  }

  // Table headers with custom column width
  headers = [
    {
      title: 'No.',
      width: '60px',
      class: 'bg-gray-7 text-gray-4 rounded-l-lg',
      customStyle: { minWidth: '60px', maxWidth: '60px' },
    },
    {
      title: 'Nama Seller',
      width: '220px',
      class: 'bg-gray-7 text-gray-4',
      customStyle: { minWidth: '200px' },
    },
    {
      title: 'Alamat',
      width: '200px',
      class: 'bg-gray-7 text-gray-4',
      customStyle: { minWidth: '160px', maxWidth: '200px' },
    },
    {
      title: 'Status',
      width: '140px',
      class: 'bg-gray-7 text-gray-4',
      customStyle: { minWidth: '110px', maxWidth: '140px' },
    },
    {
      title: 'Partner POS / Kurir',
      width: '240px',
      class: 'bg-gray-7 text-gray-4',
      customStyle: { minWidth: '200px' },
    },
    {
      title: 'Seller Role',
      width: '130px',
      class: 'bg-gray-7 text-gray-4',
      customStyle: { minWidth: '120px' },
    },
    {
      title: 'Tipe Assign',
      width: '140px',
      class: 'bg-gray-7 text-gray-4',
      customStyle: { minWidth: '110px' },
    },
  ]
  actionWidth = '280px'
  whiteListSeller = Array<any[]>([])
  loading = false

  get headerTitles(): string[] {
    return this.headers.map(h => typeof h === 'string' ? h : h.title)
  }

  created(): void {
    this.fetchWhiteList()
  }

  mounted(): void {
    document.addEventListener('click', this.handleClickOutside)
    window.addEventListener('scroll', this.handleWindowScroll, true)
  }

  beforeDestroy(): void {
    controller.setIsDeleteWhiteSellerSuccess(false)
    document.removeEventListener('click', this.handleClickOutside)
    window.removeEventListener('scroll', this.handleWindowScroll, true)
  }

  get activeFilterCount(): number {
    return this.appliedStatus.length + this.appliedRole.length
  }

  get draftStatusLabels(): string[] {
    return this.draftStatus.map(val => {
      const opt = this.statusOptions.find(o => o.value === val)
      return opt ? opt.label : val
    })
  }

  get draftRoleLabels(): string[] {
    return this.draftRole.map(val => {
      const opt = this.sellerRoleOptions.find(o => o.value === val)
      return opt ? opt.label : val
    })
  }

  get params(): Params {
    const params: Params = {
      page: this.parameters.page,
      limit: this.parameters.limit,
      query: encodeURIComponent(this.parameters.query),
    }

    if (this.appliedStatus.length === 1) {
      params.status = this.appliedStatus[0].toLowerCase()
    } else {
      params.status = 'all'
    }

    if (this.appliedRole.length > 0 && this.appliedRole.length < this.sellerRoleOptions.length) {
      params.sellerRole = this.appliedRole.join(',')
    }

    return params
  }

  get isLoadingExport(): boolean {
    return this.controller.loadingExport
  }

  private handleClickOutside(event: MouseEvent): void {
    const target = event.target as HTMLElement
    const ref = this.$refs.filterPopoverRef as HTMLElement
    if (ref && !ref.contains(target)) {
      this.closePopover()
    }
    const addressPopup = this.$refs.addressPopupRef as HTMLElement
    if (addressPopup && !addressPopup.contains(target)) {
      this.closeAddressPopup()
    }
  }

  private handleWindowScroll(event: Event): void {
    if (!this.activeAddressSellerId) return
    const popup = this.$refs.addressPopupRef as HTMLElement
    if (popup && popup.contains(event.target as Node)) {
      return
    }
    this.closeAddressPopup()
  }

  public async toggleAddressPopup(id: number, event: MouseEvent): Promise<void> {
    if (this.activeAddressSellerId === id) {
      this.closeAddressPopup()
      return
    }

    const trigger = event.currentTarget as HTMLElement
    const r = trigger.getBoundingClientRect()
    const pad = 6
    const popupWidth = 360
    const maxPopupHeight = 320

    let left = r.left
    if (left + popupWidth > window.innerWidth - 16) {
      left = window.innerWidth - popupWidth - 16
    }
    left = Math.max(16, left)

    const spaceBelow = window.innerHeight - r.bottom - pad
    const spaceAbove = r.top - pad

    const showBelow = spaceBelow >= 180 || spaceBelow >= spaceAbove

    if (showBelow) {
      const availableHeight = Math.min(maxPopupHeight, Math.max(100, spaceBelow - 16))
      this.addressPopupStyle = {
        position: 'fixed',
        top: `${r.bottom + pad}px`,
        bottom: 'auto',
        left: `${left}px`,
        width: `${popupWidth}px`,
        maxHeight: `${availableHeight}px`,
        zIndex: '1000',
      }
    } else {
      const availableHeight = Math.min(maxPopupHeight, Math.max(100, spaceAbove - 16))
      this.addressPopupStyle = {
        position: 'fixed',
        top: 'auto',
        bottom: `${window.innerHeight - r.top + pad}px`,
        left: `${left}px`,
        width: `${popupWidth}px`,
        maxHeight: `${availableHeight}px`,
        zIndex: '1000',
      }
    }

    this.activeAddressSellerId = id
    await this.fetchAddressPopup(id)
  }

  public async fetchAddressPopup(id: number): Promise<void> {
    this.isLoadingAddressPopup = true
    this.addressPopupError = false
    this.addressPopupList = []

    try {
      const resp = await WhiteSellerController.getBoundPickupPoints({
        id: String(id),
        page: 1,
        limit: 50,
        reveal: true,
      })
      this.addressPopupList = resp.data || []
    } catch (e) {
      this.addressPopupError = true
    } finally {
      this.isLoadingAddressPopup = false
    }
  }

  public retryFetchAddressPopup(): void {
    if (this.activeAddressSellerId) {
      this.fetchAddressPopup(this.activeAddressSellerId)
    }
  }

  public closeAddressPopup(): void {
    this.activeAddressSellerId = null
    this.addressPopupList = []
    this.isLoadingAddressPopup = false
    this.addressPopupError = false
  }

  public togglePopover(): void {
    this.isPopoverOpen = !this.isPopoverOpen
    if (this.isPopoverOpen) {
      this.draftStatus = [...this.appliedStatus]
      this.draftRole = [...this.appliedRole]
    }
  }

  public closePopover(): void {
    this.isPopoverOpen = false
  }

  public onDraftStatusChange(labels: string[]): void {
    this.draftStatus = labels.map(label => {
      const opt = this.statusOptions.find(o => o.label === label)
      return opt ? opt.value : label
    })
  }

  public onDraftRoleChange(labels: string[]): void {
    this.draftRole = labels.map(label => {
      const opt = this.sellerRoleOptions.find(o => o.label === label)
      return opt ? opt.value : label
    })
  }

  public handleResetDraft(): void {
    this.draftStatus = []
    this.draftRole = []
  }

  public handleApplyFilter(): void {
    this.appliedStatus = [...this.draftStatus]
    this.appliedRole = [...this.draftRole]
    this.parameters.page = 1
    this.fetchWhiteList(true)
    this.closePopover()
  }

  public handleClearTrigger(): void {
    this.appliedStatus = []
    this.appliedRole = []
    this.draftStatus = []
    this.draftRole = []
    this.parameters.page = 1
    this.fetchWhiteList(true)
    this.closePopover()
  }

  private indexTable(idx: number): string {
    const getCountData = (this.parameters.page - 1) * this.parameters.limit
    return String(getCountData + idx + 1)
  }

  private fetchWhiteList(reset?: boolean) {
    if (reset) this.parameters.page = 1
    controller.getAll(this.params)
  }

  private onSearchWhiteSeller = Utils.debounce(() => {
    this.fetchWhiteList(true)
  }, 400)

  private async onExport() {
    this.controller.exportWhiteListSeller()
  }

  private routeToAddSeller(): Location {
    return { name: 'AddSellerWhitelist' }
  }

  private routeTo(id: number, routeName: string): Location {
    return {
      name: routeName,
      params: { id: String(id) },
    }
  }

  private onDeleteModal(id: number) {
    this.deleteModal = {
      show: true,
      ids: id,
    }
  }

  private onDelete() {
    controller.deleteWhiteSeller({ ids: [this.deleteModal.ids] })
  }

  private onCloseModalSuccess() {
    this.successDeleteModal = false
    controller.setIsDeleteWhiteSellerSuccess(false)
  }

  private formatRoleLabel(role?: string): string {
    switch (role) {
      case 'TOKOPEDIA':
        return 'Tokopedia'
      case 'BUKALAPAK':
        return 'Bukalapak'
      case 'CLIENT':
        return 'Aggregator'
      case 'COMPANY':
        return 'Corporate'
      case 'MERCHANT':
        return 'Merchant'
      default:
        return role || '-'
    }
  }

  private formatAssignTypeLabel(assignType?: string): string {
    switch (assignType) {
      case 'OFFER':
        return 'Offer'
      case 'AUTO ASSIGN':
        return 'Auto Assign'
      default:
        return assignType || '-'
    }
  }

  @Watch('controller.dataWhiteListSeller')
  setDataWhiteListSeller(data: WhiteSeller[]): void {
    const result = data.map(list => {
      const partner = list.partnerPOS
        ? `${list.partnerPOS} [${list.partnerCode}] (POS)`
        : ''
      const courier = list.courierId
        ? `${list.courierId} - ${list.courierName} (Kurir)`
        : ''

      return [
        list.id,
        {
          id: list.id,
          name: list.name,
          role: list.role,
          client: list.clientName || '',
          phone: list.phone || '',
        },
        {
          id: list.id,
          address: list.address || '',
          addressCount: list.addressCount || 0,
        },
        list.status || 'INACTIVE',
        partner || courier || '-',
        this.formatRoleLabel(list.role),
        this.formatAssignTypeLabel(list.assignType)
      ]
    })
    this.whiteListSeller = <Array<any>>result
  }

  @Watch('controller.isDeleteWhiteSellerSuccess')
  setDeleteWhiteSellerSuccess(data: boolean): void {
    this.deleteModal.show = false
    if (data) {
      this.fetchWhiteList(true)
      this.successDeleteModal = data
    }
  }

  async showPhoneNumber(id = 0): Promise<void> {
    try {
      const resp = await PickupController.adminContactShow({
        resource: 'whitelist_seller',
        resourceId: String(id),
        field: 'whitelist_phone',
        source: 'whitelist-detail'
      });
      const phone = resp.value;
      const list = controller.dataWhiteListSeller.map((seller) => {
        if (seller.id === id) {
          seller.phone = phone;
          return seller
        }

        return seller
      });
      this.setDataWhiteListSeller(list);
    } finally {
      // no loading
    }
  }

  hidePhoneNumber(id = 0): void {
    const list = controller.dataWhiteListSeller.map((seller) => {
      if (seller.id === id) {
        seller.phone = "";
        return seller
      }

      return seller
    });
    this.setDataWhiteListSeller(list);
  }
}
export default ManageWhitelist;
